/**
 * Credits for the closing slide.
 */
export type CreditItem = { title: string; names: string };

/** Trailing note rendered as a paragraph after the credits list (empty to hide). */
export const creditsNote = "";

export const credits: ReadonlyArray<CreditItem> = [
  { title: "Editors", names: "Kevin Nguyen, Meredith Haggerty" },
  { title: "Photographer", names: "Stephen Voss" },
  { title: "Photo Editor", names: "Amelia Holowaty Krales" },
  { title: "Art Director/Designer", names: "Cath Virginia" },
  { title: "Engineer", names: "Graham MacAree" },
  { title: "Copy Editor", names: "Kallie Plagge" },
  { title: "Fact Checkers", names: "Becca Laurie, Helen Li" },
  {
    title: "Engagement",
    names: "Tristan Cooper, Caitlin Petrakovitz, Alexandria Watts",
  },
  { title: "Creative Director", names: "Kristen Radtke" },
  { title: "Managing Editor", names: "Kara Verlaney" },
  { title: "Editor-in-Chief", names: "Nilay Patel" },
  { title: "Publisher", names: "Helen Havlak" },
];
